module.exports = __webpack_public_path__ + "static/media/icon-settings.26e0f8b0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/NavNoLogout/assets/icon-settings.svg
// module id = 1843
// module chunks = 193